<template>
  <div class="card rounded-0">
    <div class="card-header">
      <h3 class="mb-0 text-left">Edit TLS</h3>
    </div>
    <div class="card-body">
      <loading
        :active.sync="editLoading"
        color="#5739B2"
        :z-index="9"
      ></loading>
      <b-form-group label="Domain">
        <b-form-input
          v-model="form.domain"
          type="text"
          placeholder="Enter domain"
        >
        </b-form-input>
        <span v-if="error['domain']" class="text-danger">
          {{ error["domain"] }}
        </span>
      </b-form-group>
      <b-form-group label="Match Ip Address">
        <b-form-input
          v-model="form.match_ip_address"
          type="text"
          placeholder="Enter match ip address"
        >
        </b-form-input>
        <span v-if="error['match_ip_address']" class="text-danger">
          {{ error["match_ip_address"] }}
        </span>
      </b-form-group>
      <b-form-group label="Match Sip Domain">
        <b-form-input
          v-model="form.match_sip_domain"
          type="text"
          placeholder="Enter Match Sip Domain"
        >
        </b-form-input>
        <span v-if="error['match_sip_domain']" class="text-danger">
          {{ error["match_sip_domain"] }}
        </span>
      </b-form-group>
      <b-form-group label="Type">
        <b-form-input v-model="form.type" type="text" placeholder="Enter Type">
        </b-form-input>
        <span v-if="error['type']" class="text-danger">
          {{ error["type"] }}
        </span>
      </b-form-group>
      <b-form-group label="Method">
        <b-form-input
          v-model="form.method"
          type="text"
          placeholder="Enter Method"
        >
        </b-form-input>
        <span v-if="error['method']" class="text-danger">
          {{ error["method"] }}
        </span>
      </b-form-group>
      <b-form-group label="Verify Cert">
        <b-form-input
          v-model="form.verify_cert"
          type="text"
          placeholder="Enter Verify Cert"
        >
        </b-form-input>
        <span v-if="error['verify_cert']" class="text-danger">
          {{ error["verify_cert"] }}
        </span>
      </b-form-group>
      <b-form-group label="Require Cert">
        <b-form-input
          v-model="form.require_cert"
          type="text"
          placeholder="Enter Require Cert"
        >
        </b-form-input>
        <span v-if="error['require_cert']" class="text-danger">
          {{ error["require_cert"] }}
        </span>
      </b-form-group>
      <b-form-group label="CRL Check All">
        <b-form-input
          v-model="form.crl_check_all"
          type="text"
          placeholder="Enter CRL Check All"
        >
        </b-form-input>
        <span v-if="error['crl_check_all']" class="text-danger">
          {{ error["crl_check_all"] }}
        </span>
      </b-form-group>
      <b-form-group label="CA Dir">
        <b-form-input
          v-model="form.ca_dir"
          type="text"
          placeholder="Enter CA Dir"
        >
        </b-form-input>
        <span v-if="error['ca_dir']" class="text-danger">
          {{ error["ca_dir"] }}
        </span>
      </b-form-group>
      <b-form-group label="Certificate">
        <b-form-textarea
          v-model="form.certificate"
          type="text"
          placeholder="Enter Certificate"
        >
        </b-form-textarea>
        <span v-if="error['certificate']" class="text-danger">
          {{ error["certificate"] }}
        </span>
      </b-form-group>
      <b-form-group label="Private Key">
        <b-form-textarea
          v-model="form.private_key"
          type="text"
          placeholder="Enter Private Key"
        >
        </b-form-textarea>
        <span v-if="error['private_key']" class="text-danger">
          {{ error["private_key"] }}
        </span>
      </b-form-group>
      <b-form-group label="CA List">
        <b-form-textarea
          v-model="form.ca_list"
          type="text"
          placeholder="Enter CA List"
        >
        </b-form-textarea>
        <span v-if="error['ca_list']" class="text-danger">
          {{ error["ca_list"] }}
        </span>
      </b-form-group>

      <b-button variant="primary" @click.prevent="edit">Edit</b-button>
    </div>
  </div>
</template>

<script>
import http from "@/axios";

export default {
  data() {
    return {
      editLoading: false,
      form: {},
      error: {},
    };
  },
  mounted() {
    this.getTls();
  },
  methods: {
    async getTls() {
      const id = this.$route.params.id;
      const res = await http.get(`sbc/tls-mgm/show/${id}`);
      this.form = res.data.data;
    },
    async edit() {
      const id = this.$route.params.id;

      try {
        this.editLoading = true;
        await http.put(`sbc/tls-mgm/${id}`, this.form);
        this.$router.push({ name: "all-settings" });
        this.editLoading = false;
      } catch (error) {
        this.editLoading = false;
        this.error = error.response.data.error;
      }
    },
  },
};
</script>

<style></style>
